import { Alignment, ModelRow } from "@mcleod/core";
import {
    Button, ClickEvent, DataSourceMode, Event, Layout, SelectionType, SlideoutDecorator, SlideoutDecoratorProps,
    TableRowDisplayEvent, Textbox
} from "@mcleod/components";
import { CommonDialogs } from "@mcleod/common";
import { AutogenLayoutEditSendToLanes } from "./autogen/AutogenLayoutEditSendToLanes";
import { LocationByTypeProps, LocationByTypeUtil } from "./LocationByTypeUtil";

const LOCATION_BY_TYPE_PROPS: LocationByTypeProps = {
    stateType: 'S',
    zoneType: 'Z',
    marketAreaType: 'M',
    useDefault: true,
    allowFreeform: true
}

export class EditSendToLanes extends AutogenLayoutEditSendToLanes {
    private _lanes: string[] = [];
    private _starLane: boolean = false;

    tableLanesOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        const laneSelected = this.starLane || this.lanes.includes(modelRow.getNumber('lane_number').toString());
        if (laneSelected) {
            this.tableLanes.selectRow(tableRow, SelectionType.DISTINCT, null);
        }

        const textboxOriginType = tableRow.findComponentById("textboxOriginType") as Textbox;
        textboxOriginType.required = false;
        const textboxDestinationType = tableRow.findComponentById("textboxDestinationType") as Textbox;
        textboxDestinationType.required = false;
        const textboxOrigin = tableRow.findComponentById("textboxOrigin") as Textbox;
        const textboxDestination = tableRow.findComponentById("textboxDestination") as Textbox;
        LocationByTypeUtil.setupLocationTypeChangeListener(textboxOriginType, textboxOrigin, LOCATION_BY_TYPE_PROPS);
        LocationByTypeUtil.setupLocationTypeChangeListener(textboxDestinationType, textboxDestination, LOCATION_BY_TYPE_PROPS);
    }

    static showSlideout(carrier: string, contactName: string, contactLanes: string, onSave: (string) => void, overrideLanes?: ModelRow[], props?: Partial<SlideoutDecoratorProps>) {
        const buttonSave = new Button({
            caption: "Apply Edits",
            backgroundColor: "primary",
            minWidth: 128,
            borderWidth: 0,
            rowBreak: false
        });

        const decorator = new SlideoutDecorator({
            layout: Layout.getLayout('lme/dispatch/EditSendToLanes', { fillHeight: true }),
            fillHeight: true,
            width: '60%',
            minWidth: 725,
            title: `Edit Lanes`,
            overlayProps: { closeOnClickOff: false, greyedBackground: true },
            transitionOptions: { speed: 200, direction: Alignment.RIGHT },
            addlComponents: buttonSave,
            layoutLoadListeners: async (event: Event) => {
                const layout = event.target as EditSendToLanes;
                layout.lanes = contactLanes;
                layout.labelTitle.text = layout.labelTitle.text + contactName;
                if (overrideLanes) {
                    layout.mainDataSource.setRowsAndMode(DataSourceMode.NONE, overrideLanes);
                } else {
                    await layout.mainDataSource.search({ "master_type": "C", "master_id": carrier });
                }
            },
            ...props
        });

        buttonSave.addClickListener((event: ClickEvent) => {
            buttonSave.busy = true;
            const layout = decorator.layout as EditSendToLanes;
            let starLane = true;
            let atLeastOneSelected = false;
            const lanes = layout.tableLanes.allRows
                .map(row => {
                    const modelRow = row.data as ModelRow;
                    if (!atLeastOneSelected) {
                        atLeastOneSelected = row.selected;
                    }
                    starLane = starLane && row.selected;
                    return row.selected ? modelRow.getNumber('lane_number', 0) : 0;
                })
                .filter(lane => lane > 0)
                .map(lane => lane.toString())
                .join(',');
            buttonSave.busy = false;
            if (atLeastOneSelected) {
                decorator.slideOut();
                onSave(starLane ? '*' : lanes);
            } else {
                CommonDialogs.showError("At least one lane must be selected.");
            }
        });
    }

    public get lanes(): string[] {
        return this._lanes;
    }

    public set lanes(value: string) {
        this._lanes = value.split(',');
        this._starLane = this._lanes.includes('*');
    }

    public get starLane(): boolean {
        return this._starLane;
    }
}
